import { IFormFields } from '@components/ui-upsert-page/ui-form.component';
import {
    IProcess,
    IQueue,
    ITriggerUpsert,
    JobStartStrategy,
    StopStrategy,
    TriggerType,
} from '@models';

export interface ITriggerStopAfter {
    stopEnabled: boolean;
    stopDays: number;
    stopHours: number;
    stopMinutes: number;
    stopStrategy: StopStrategy | null;
}

export interface ITriggerUpsertContext {
    type: TriggerType;
    queue?: {
        id: number,
        name: string,
        data: IQueue,
    };
    process?: {
        id: number,
        name: string,
        data: IProcess,
    };
    environmentId?: number;
}

export interface ITriggerOption {
    id: TriggerType;
    svgIcon?: string;
    matIcon?: string;
    title: string;
    subtitle: string;
    disabled: boolean;
}

export const TRIGGER_TYPES: ITriggerOption[] = [
    {
        id: TriggerType.Time,
        svgIcon: 'uipath:timeTrigger',
        title: 'trigger_type_Time',
        subtitle: 'time_trigger_subtitle',
        disabled: false,
    },
    {
        id: TriggerType.Queue,
        svgIcon: 'uipath:queueTrigger',
        title: 'trigger_type_Queue',
        subtitle: 'queue_trigger_subtitle',
        disabled: true,
    },
];

export const TRIGGER_MAX_NAME_LENGTH = 255;
export const ITEMS_ACTIVATION_MAX = 10000;
export const ITEMS_PER_JOB_ACTIVATION_MAX = 10000;
export const MAX_JOBS_ACTIVATION_MAX = 10000;
export const STOP_DAYS_MAX = 10;
export const STOP_HOURS_MAX = 23;
export const STOP_MINUTES_MAX = 59;
export const START_STRATEGY_JOB_MIN_NO_OF_JOBS = 1;

export const TRIGGER_FORM_FIELDS: IFormFields<ITriggerUpsert> = {
    id: 'id',
    type: 'type',
    name: 'name',
    process: 'process',
    startStrategyRadio: 'startStrategyRadio',
    startStrategy: 'startStrategy',
    executorRobots: 'executorRobots',
    inputArguments: 'inputArguments',
    timezone: 'timezone',
    useCalendar: 'useCalendar',
    calendar: 'calendar',
    stopEnabled: 'stopEnabled',
    stopDays: 'stopDays',
    stopHours: 'stopHours',
    stopMinutes: 'stopMinutes',
    stopStrategy: 'stopStrategy',
    disableAfter: 'disableAfter',
    stopProcessDate: 'stopProcessDate',
    queue: 'queue',
    itemsActivationThreshold: 'itemsActivationThreshold',
    itemsPerJobActivationTarget: 'itemsPerJobActivationTarget',
    maxJobsForActivation: 'maxJobsForActivation',
    startProcessCron: 'startProcessCron',
    startProcessCronDetails: 'startProcessCronDetails',
    enabled: 'enabled',
    externalJobKey: 'externalJobKey',
    environmentId: 'environmentId',
    startProcessCronObj: 'startProcessCronObj',
};

export const QUEUE_TRIGGER_SPECIFIC_FIELDS: (keyof ITriggerUpsert)[] = [
    'queue',
    'itemsActivationThreshold',
    'itemsPerJobActivationTarget',
    'maxJobsForActivation',
];

export const TIME_TRIGGER_SPECIFIC_FIELDS: (keyof ITriggerUpsert)[] = [
    'stopEnabled',
    'stopDays',
    'stopHours',
    'stopMinutes',
];

export const START_STRATEGY = new Map<JobStartStrategy, 0 | -1 | 1>([
    [JobStartStrategy.AllRobots, -1],
    [JobStartStrategy.SpecificRobots, 0],
    [JobStartStrategy.JobsCount, START_STRATEGY_JOB_MIN_NO_OF_JOBS],
]);
